var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgE3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 169,
    viewBox: "0 0 200 169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(-773.5 -2014)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_2.",
    "data-name": 2,
    transform: "translate(828.5 2136)",
    fill: "#9c3230",
    fontSize: 100,
    fontFamily: "Oswald-Bold, Oswald",
    fontWeight: 700,
    letterSpacing: "-0.014em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -37.2,
    y: 0
  }, "2.")), /*#__PURE__*/React.createElement("text", {
    id: "_5x",
    "data-name": "5x",
    transform: "translate(905.5 2136)",
    fill: "#9c3230",
    fontSize: 100,
    fontFamily: "Oswald-Bold, Oswald",
    fontWeight: 700,
    letterSpacing: "-0.014em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -43.5,
    y: 0
  }, "5"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "Oswald-ExtraLight, Oswald",
    fontWeight: 200
  }, "x")), /*#__PURE__*/React.createElement("text", {
    id: "Emotional_abuse_is",
    "data-name": "Emotional abuse is",
    transform: "translate(872.5 2038)",
    fill: "#1d1d1d",
    fontSize: 20,
    fontFamily: "Oswald-Medium, Oswald",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -82.47,
    y: 0
  }, "EMOTIONAL ABUSE IS")), /*#__PURE__*/React.createElement("text", {
    id: "more_common_between_partners_than_physical_abuse",
    "data-name": "more common between partners than physical abuse",
    transform: "translate(873.5 2160)",
    fill: "#1d1d1d",
    fontSize: 16,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -85.36,
    y: 0
  }, "more common between "), /*#__PURE__*/React.createElement("tspan", {
    x: -99.768,
    y: 20
  }, "partners than physical abuse")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgE3);
export default __webpack_public_path__ + "static/media/e3.43868414f92267a242b5295b3a4cbb67.svg";
export { ForwardRef as ReactComponent };